import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const BookTariffOptionsModule = {
  namespaced: true,
  state: {
    view: 'viewOptions',
    selectedTariffOptions: [],
    dataResponseOptions: [],
    bookedOptions: [],
    notBookedOptions: [],
    processId: null,
    bookTariffoptionDocumentUrl: null
  },
  actions: {
    async transmitTariffOptions ({ commit, state }, { nextStep }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      const options = state.selectedTariffOptions
      const mutations = options.map(option => {
        return `${option.tariffoptionId}: bookTariffoption(bookTariffoption: {
          tariffoptionId: "${option.tariffoptionId}"
        }) {
          success
         }`
      }).join('\n')
      const request = `mutation bookTariffOptions {
        ${mutations}
      }`
      return apolloClient.mutate({
        mutation: gql`${request}`
      }).then((response) => {
        if (response.data) {
          commit('successfulOptions', response.data)
          commit('changeStep', nextStep)
          commit('Transaction/removeTransactionId', 'bookTariffOptions', { root: true })
        }
      }).catch((error) => {
        commit('successfulOptions', error.networkError?.result?.data || {})
        const errors = splitError(error)
        commit('errorOptions', errors)

        errors.forEach(e => commit('addError', e, { root: true }))
        if (state.bookedOptions.length > 0) {
          commit('changeStep', nextStep)
        }
      })
    },
    async deactivateTariffOption ({ commit, state, getters, rootGetters }, { tariffoptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation bookTariffoption ($deleteTariffoptionInput: DeleteTariffoptionInput!) {
          deleteTariffoption (deleteTariffoption: $deleteTariffoptionInput){
            success
          }
        }`,
        variables: {
          deleteTariffoptionInput: {
            tariffoptionId: tariffoptionId
          }
        }
      }).then((response) => {
        commit('changeStep', 'success')
        return response.data.deleteTariffoption.success
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async bookTariffoption ({ commit, state, getters, rootGetters }, { tariffoptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($bookTariffoptionInput: BookTariffoptionInput!) {
          bookTariffoption (bookTariffoption: $bookTariffoptionInput){
            success,
            processId,
            bookTariffoptionDocumentUrl
          }
        }`,
        variables: {
          bookTariffoptionInput: {
            tariffoptionId: tariffoptionId
          }
        }
      }).then((response) => {
        commit('processId', response.data.bookTariffoption.processId)
        commit('storeBookTariffoptionDocumentUrl', response.data.bookTariffoption.bookTariffoptionDocumentUrl)
        return response.data.bookTariffoption
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async initiateCancelTariffOption ({ commit, state }, { tariffoptionId }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      commit('processId', null)
      return apolloClient.mutate({
        mutation: gql`mutation tariffStatus ($initiateCancelTariffoptionInput: InitiateCancelTariffoptionInput!){
          initiateCancelTariffoption (initiateCancelTariffoption: $initiateCancelTariffoptionInput) {
            success
            processId
            cancelTariffoptionDocumentUrl
          }
        }`,
        variables: {
          initiateCancelTariffoptionInput: {
            tariffoptionId: tariffoptionId
          }
        }
      }).then((response) => {
        commit('processId', response.data.initiateCancelTariffoption.processId)
        commit('storeBookTariffoptionDocumentUrl', response.data.initiateCancelTariffoption.cancelTariffoptionDocumentUrl)
        return response.data.initiateCancelTariffoption
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async cancelTariffOptionConfirm ({ commit, state }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation tariffStatus ($input: ConfirmCancelTariffoptionInput!) {
          confirmCancelTariffoption (confirmCancelTariffoption: $input) {
            success
          }
        }`,
        variables: {
          input: {
            processId: state.processId
          }
        }
      }).then((response) => {
        commit('resetState')
        commit('Transaction/removeTransactionId', 'tariffStatus', { root: true })
        return response.data.confirmCancelTariff
      }).catch((error) => {
        commit('processId', null)
        commit('contractUrl', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmTariffoption ({ commit, state, getters, rootGetters }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($confirmTariffoptionBookingInput: ConfirmTariffoptionBookingInput!) {
          confirmTariffoptionBooking (confirmTariffoptionBooking: $confirmTariffoptionBookingInput){
            success
          }
        }`,
        variables: {
          confirmTariffoptionBookingInput: {
            processId: state.processId
          }
        }
      }).then((response) => {
        if (response.data.confirmTariffoptionBooking.success) {
          commit('changeStep', 'success')
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async updateServiceOption ({ commit, state }, status) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation
        serviceOptions ($changeServiceOptionsInput: ChangeServiceOptionsInput!){
            changeServiceOptions(changeServiceOptions: $changeServiceOptionsInput) {
                success
            }
        }`,
        variables: {
          changeServiceOptionsInput: {
            anonymousCallRejection: status
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'serviceOptions', { root: true })
        commit('changeStep', 'success')
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        commit('changeStep', 'viewOptions')
      })
    }
  },
  mutations: {
    changeStep (state, step) {
      state.view = step
    },
    successfulOptions (state, options) {
      state.bookedOptions = Object.entries(options)
        .filter(([key, value]) => value !== null)
        .map(([key, value]) => {
          return {
            tariffoptionId: key,
            success: value
          }
        })
    },
    errorOptions (state, options) {
      state.notBookedOptions = options.map(error => {
        const id = error.path[0]
        return {
          tariffoptionId: id,
          message: error.message
        }
      })
    },
    saveTariffOptions (state, options) {
      state.selectedTariffOptions = options
    },
    processId (state, id) {
      state.processId = id
    },
    storeBookTariffoptionDocumentUrl: (state, bookTariffoptionDocumentUrl) => {
      state.bookTariffoptionDocumentUrl = bookTariffoptionDocumentUrl
    }
  },
  getters: {
    getStep: state => {
      return state.view
    },
    getView: state => {
      return state.view
    },
    getProcessId: state => {
      return state.processId
    },
    getDataResponseOptions: state => {
      return [{ ...Object.assign(state.dataResponseOptions, state.selectedTariffOptions) }]
    },
    getSuccessfulOptions: state => {
      return state.bookedOptions
    },
    getErrorOptions: state => {
      return state.notBookedOptions
    },
    bookTariffoptionDocumentUrl: state => {
      return state.bookTariffoptionDocumentUrl
    }
  }
}

export {
  BookTariffOptionsModule
}
